import { useState, useEffect } from "react";
import { getSupplierContacts } from "../../services/campaign.service";
import { useOktaAuth } from "@okta/okta-react";
import Select from "react-select";
import { Button, TextField, Grid, Typography } from "@deere/fuel-react";
import { ERR_EXISTING_CONTACT, ERR_SELECT_OPTION } from "../../utils/errorLiterals";

const AutocompleteSupplierContacts = ({ supplierNumber, supplierContacts, setSupplierContacts, valid, isNonDeere, campaignId }) => {
  const [optAutocomplete, setOptAutocomplete] = useState([]);
  const [newInput, setNewInput] = useState(null);
  const [error, setError] = useState("");
  const [isAddDisabled, setIsAddDisabled] = useState(false);
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (supplierNumber && supplierNumber !== "") {
      getSupplierContacts(supplierNumber, campaignId, authState.accessToken.accessToken).then((res) => {
        let tempContacts = [];
        if (res && res !== null) {
          res.forEach((contact) => {
            let contactUserId = contact && contact.contactUserId ? contact.contactUserId : (contact.contactUID || "");
            let label = (contact && contact.displayName) || contactUserId;
            tempContacts.push({ label, value: contactUserId });
          });
        }
        setOptAutocomplete(tempContacts);
      });
    }
  }, [supplierNumber]);

  useEffect(() => {
    if (isNonDeere) {
      valid && newInput && newInput.value !== "" ? setIsAddDisabled(false) : setIsAddDisabled(true);
    } else {
      valid && optAutocomplete.length > 0 ? setIsAddDisabled(false) : setIsAddDisabled(true);
    }
  }, [valid, optAutocomplete, newInput]);

  const isOptionSelected = (option, values) => {
    return values.some(({ value }) => option.value === value);
  };

  const changeHandler = (event) => {
    isNonDeere ? setNewInput({ label: event.target.value, value: event.target.value }) : setNewInput(event);
    setError("");
  };

  const customStyles = {
    option: (provided, state) => ({ ...provided, color: state.isSelected ? "black" : "black" }),
    control: (base) => ({ ...base, height: 35, minHeight: 35, width: "auto" }),
    menu: (base) => ({ ...base, position: "relative" }),
    dropdownIndicator: (base) => ({ ...base, height: 35, minHeight: 35 }),
    placeholder: (base) => ({ ...base }),
    valueContainer: (base) => ({ ...base, height: 35, minHeight: 35 }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      return { ...provided, opacity };
    },
  };

  const addHandler = () => {
    if (newInput && newInput !== null) {
      let alreadyExists = supplierContacts.find((item) => item.value === newInput.value);
      if (alreadyExists) setError(ERR_EXISTING_CONTACT);
      else {
        setSupplierContacts((prevState) => [...prevState, newInput]);
        setNewInput("");
        setError("");
      }
    } else setError(ERR_SELECT_OPTION);
  };

  return (
    <>
      <Grid container justifyContent="space-around" spacing={2}>
        <Grid item xs={10}>
          {isNonDeere ? (
            <TextField placeholder="Enter Supplier Contact" value={newInput ? newInput.value : ""} onChange={changeHandler} disabled={!valid} />
          ) : (
            <Select
              cacheOptions={true}
              defaultOptions
              options={optAutocomplete}
              isOptionSelected={isOptionSelected}
              value={newInput}
              isClearable={true}
              styles={customStyles}
              noOptionsMessage={() => "Start Typing..."}
              onChange={changeHandler}
              isDisabled={!valid}
            />
          )}
        </Grid>
        <Grid item xs={2}>
          <Button variant="secondary" disabled={isAddDisabled} onClick={addHandler}>
            Add
          </Button>
        </Grid>
      </Grid>
      {error !== "" && <Typography variant="div" style={{ color: "red", fontSize: "smaller" }}>{error}</Typography>}
    </>
  );
};

export default AutocompleteSupplierContacts;
